import React from "react";
import PropTypes from "prop-types";
import ItemMenuIcon from "../ItemMenuIcon/ItemMenuIcon";
import ItemMenuEvent from "../ItemMenuEvent/ItemMenuEvent";
import ItemMenuImage from "../ItemMenuImage/ItemMenuImage";
import ItemMenuSolution from "../ItemMenuSolution/ItemMenuSolution";
import ItemMenuDomains from "../ItemMenuDomains/ItemMenuDomains";
import ItemMenuSmImage from "../ItemMenuSmImage/ItemMenuSmImage";
import { trackSubmenuClick } from "../../lib/analytic/trackMainMenu";

const ItemMenu = ({
  link,
  isMobile,
  viewMode,
  handleSolutionMouseOver,
  handleSolutionMouseOut,
  handleSolutionFilter,
  toggleModal,
}) => {
  // type, url, link text, title, img, body text.
  const { url, title, extraClass, type, linkViewMode } = link;
  const typeOfLink = type || "default";
  const additionalClass = extraClass || "";
  const linkClass = `sub-link sub-link--default ${additionalClass}`;
  // Bool var for render default type of link.
  // Type body-icon have default view on mobile.
  const renderDefaultLink =
    typeOfLink === "default" || (typeOfLink === "body-icon" && isMobile);
  const handleClickForAnalytics = (titleOfLink, urlOfLink) => {
    trackSubmenuClick(titleOfLink, urlOfLink);
  };
  return (
    <li>
      {renderDefaultLink && (
        <a
          href={url}
          className={linkClass}
          onClick={(e) => {
            if (isMobile && e.target.href.indexOf(window.location.href) > -1) {
              toggleModal(e);
            }
            handleClickForAnalytics(title, url);
          }}
          role="menuitem"
        >
          {title}
        </a>
      )}
      {typeOfLink === "body-icon" && !renderDefaultLink && (
        <ItemMenuIcon link={link} handleClick={handleClickForAnalytics} />
      )}
      {typeOfLink === "event" && (
        <ItemMenuEvent link={link} handleClick={handleClickForAnalytics} />
      )}
      {(typeOfLink === "body-image" && linkViewMode !== "menu_solution") && (
        <ItemMenuImage link={link} handleClick={handleClickForAnalytics} />
      )}
      {(typeOfLink === "body-image" && linkViewMode === "menu_solution") && (
        <ItemMenuSolution
          link={link}
          handleClick={handleClickForAnalytics}
          handleOnMouseOver={handleSolutionMouseOver}
          handleOnMouseOut={handleSolutionMouseOut} />
      )}
      {(typeOfLink === "title-image" && viewMode !== "menu_domains") && (
        <ItemMenuSmImage link={link} handleClick={handleClickForAnalytics} />
      )}
      {(typeOfLink === "title-image" && viewMode === "menu_domains") && (
        <ItemMenuDomains link={link} handleClick={handleSolutionFilter} isMobile={isMobile} />
      )}
    </li>
  );
};

ItemMenu.propTypes = {
  link: PropTypes.object.isRequired,
  isMobile: PropTypes.bool.isRequired,
  viewMode: PropTypes.string,
  toggleModal: PropTypes.func,
};

export default ItemMenu;
